/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */
import WyFilter from '../../library/wy-filter.js';
import WyGenie from '../../library/wy-genie.js';
import hash from 'object-hash';
import GenieService from '../../service/genie';

const state = {
  contactReasonRunStats: null,
  transcriptInfoReference: null,
};

const getters = {
  
};

const mutations = {
  
};

const actions = {
  async fetchGenieSession({getters}, data) {
    const payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.topics = data.topics;
    payload.topicDisplayName = data.topicDisplayName;

    if (data.isOthers != undefined) payload.isOthers = data.isOthers;
    if (data.date) {
      payload.dateStart = data.date;
      payload.dateEnd = data.date;
    }

    // get payload hash
    const payloadHash = hash(payload);
    // get genie bot session ID by payload hash
    const genieSession = WyGenie.getGenieCachedSessionId(getters.authUser, payloadHash);
    if(genieSession) {
      return genieSession;
    }
    else {
     
      // init genie session
      const resGeniBotSession = await GenieService.initGenieSession(getters.authUser, payload);
      if(resGeniBotSession && resGeniBotSession.status == 200) {
        if(resGeniBotSession.data && resGeniBotSession.data["sessionId"]) {
          // set and cache genie bot session ID
          WyGenie.createGenieCachedSessionId(getters.authUser, payloadHash, resGeniBotSession.data);

          return resGeniBotSession.data;
        }
      }

      return null
    }
  },

  async postGenieLogging({getters}, data) {
    await GenieService.postGenieLogging(getters.authUser, data);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
